import { Routes } from '@angular/router';

import { setupFeatureFlagsForModule } from '@core/shared/util';

import { ListPlatformPackagingUnitsComponent } from './list/list-platform-packaging-units.component';

const baseTitle = 'System | Plattformeinheit';

export const PLATFORM_PACKAGING_UNITS_ROUTES: Routes = [
  {
    path: '',
    data: setupFeatureFlagsForModule({ customHeader: true }),
    component: ListPlatformPackagingUnitsComponent,
    title: `${baseTitle}en`,
    children: [
      {
        path: 'create',
        loadComponent: async () =>
          (await import('./create/create-platform-packaging-unit.component')).CreatePlatformPackagingUnitComponent,
        title: `${baseTitle} anlegen`,
      },
      {
        path: ':shortName',
        loadComponent: async () =>
          (await import('./edit/edit-platform-packaging-unit.component')).EditPlatformPackagingUnitComponent,
        title: `${baseTitle}endetails`,
      },
    ],
  },
];
